// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .fileuploader-container {
  margin: 0;
  max-height: 50px;
}

::ng-deep .dx-fileuploader-wrapper {
  padding: 0;
}

::ng-deep .dx-fileuploader-input-wrapper {
  float: left;
  max-width: 120px;
  padding: 0;
}

::ng-deep .dx-fileuploader-invalid .dx-fileuploader-cancel-button {
  margin-top: 0;
}

::ng-deep .dx-fileuploader-button-container {
  padding-top: 3px;
  vertical-align: top;
}

::ng-deep.dx-fileuploader-file {
  padding-top: 1px;
}

::ng-deep .dx-fileuploader-content > .dx-fileuploader-upload-button {
  display: none;
}

::ng-deep .dx-fileuploader-file-container .dx-button:has(> div.dx-button-content > i.dx-icon-upload) {
  display: none;
}

::ng-deep .dx-fileuploader-show-file-list .dx-fileuploader-files-container {
  padding: 0;
}

.note {
  font-weight: 500;
}

.block {
  display: block;
}

.span-file-view {
  float: left;
  margin-top: 7px;
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
}

.btn-file {
  float: left;
  margin: 5px;
}

::ng-deep i.dx-icon.fa.btn-color {
  color: #337ab7;
}`, "",{"version":3,"sources":["webpack://./src/app/subticket/subticket.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":["::ng-deep .fileuploader-container {\n  margin: 0;\n  max-height: 50px;\n}\n\n::ng-deep .dx-fileuploader-wrapper {\n  padding: 0;\n}\n\n::ng-deep .dx-fileuploader-input-wrapper {\n  float: left;\n  max-width: 120px;\n  padding: 0;\n}\n\n::ng-deep .dx-fileuploader-invalid .dx-fileuploader-cancel-button {\n  margin-top: 0;\n}\n\n::ng-deep .dx-fileuploader-button-container {\n  padding-top: 3px;\n  vertical-align: top;\n}\n\n::ng-deep.dx-fileuploader-file {\n  padding-top: 1px;\n}\n\n::ng-deep .dx-fileuploader-content > .dx-fileuploader-upload-button {\n  display: none;\n}\n\n::ng-deep .dx-fileuploader-file-container .dx-button:has(> div.dx-button-content > i.dx-icon-upload) {\n  display: none;\n}\n\n::ng-deep .dx-fileuploader-show-file-list .dx-fileuploader-files-container {\n  padding: 0;\n}\n\n.note {\n  font-weight: 500;\n}\n\n.block {\n  display: block;\n}\n\n.span-file-view {\n  float: left;\n  margin-top: 7px;\n  max-width: 500px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-wrap: nowrap;\n}\n\n.btn-file {\n  float: left;\n  margin: 5px;\n}\n\n::ng-deep i.dx-icon.fa.btn-color {\n  color: #337ab7;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
